<template>
<div class="page impressum">
      <page-header :data="data.extHeader"></page-header>
      <section class="section section--header">
        <div class="background-layer">
          <img :src="data.images.hero" class="img" alt="hero-img">
        </div>
      </section>
      <section class="section section--content">
        <div class="container mb-5">
          <h1 class="section__headline">Impressum</h1>
          <!-- <h3 class="section__subheadline mb-4">Liability for Content</h3> -->
          <p class="text mb-3">
          <strong>DigitalHealthTechnology GmbH </strong> <br />

            a joint venture of Nuromedia GmbH & Nurogames GmbH <br />

            Schaafenstr. 25, D-50676 Köln / Germany <br />

            www.digitalhealth.technology | info@digitalhealth.technology <br />

            Tel.:  +49 221 398 80 840  | Fax.: +49 221 398 80 01 <br />

            Registernr.: HRB 99459, Amtsgericht Köln <br />
            </p>

            <p class="text mb-3">
              Geschäftsführer: Andrii Pomazanskyi
            </p>

            <p class="text mb-3">
              NUROMEDIA GmbH <br />

              Schaafenstraße 25 <br />

              50674 Köln / Germany <br />

              www.nuromedia.de <br />

              info@nuromedia.com <br />

              Tel.: +49 221 398 80826 <br />

              Fax.: +49 221 398 8003 <br />
            </p>

            <p class="text mb-3">
              Geschäftsführer: Jens Piesk
            </p>

            <p class="text mb-3">
              Sitz und Registergericht:

              Köln HRB 57289

              USt. ID Nr.: DE814670158
            </p>

        </div>
      </section>

      <page-footer :data="data.footer"></page-footer>

</div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'Impressum',
  props: ['data'],
  components: {
    'page-header': Header,
    'page-footer': Footer,
  },
  data() {
    return this.data;
  }
}
</script>

<style lang="scss">
.page.impressum {
  position: relative;
  background-color: $white;

    .img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .page-header {
    top: 0;
  }

  .text {
      font-size: 1.25rem;
      color: $gray;
      text-align: left;
    }

  .section {
    height: auto;
    width: 100%;
    max-width: 100vw;
    position: relative;

    &__headline {
      position: relative;
      font-size: 3.125rem;
      color: $black;
      font-weight: bold;
      text-align: center;
      height: 7.5rem;
      &::after {
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 9.375rem;
        height: .625rem;
        background-color: $secondary;
        content: '';
      }
    }

    &__subheadline {
      font-size: 1.875rem;
      color: $black;
      font-weight: bold;
      text-align: center;
    }
  }

  .section.section--header {
    height: 7rem;

    .background-layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      max-height: 100%;
      overflow: hidden;
      background-color: $dark-blue;
      z-index: 0;
    }
  }

  .page-footer {

    margin-top: 1rem;
    border-top: solid 2px $primary;

    .text {
    font-size: 1rem;
    text-align: center;
    }
  }

}
</style>
